import request from '@/utils/request'
import { INVENTORY_STATUSES_EXCEL_URL, INVENTORY_STATUSES_URL } from './endpoints'
import { InventoryWarehouse, IvlInventoryExportRequest, IvlInventoryRequest, ivlInventoryResultSchema } from './ivlTypes'
import { toRepeatQuery } from './queryString'
import { IVL_INVENTORY_FLAG } from './ivlConstants'
import { IVL_CONTRACT_ERROR_MESSAGE, IvlInventoryUserError } from './ivlErrorMessages'

export const INVENTORY_CONTRACT_ERROR = IVL_CONTRACT_ERROR_MESSAGE

/** false 본문도 request.get이 받도록 감싼다. 통신 실패를 OFF로 간주하지 않는다. */
export const getIvlInventoryEnabled = async (): Promise<boolean> => {
  const response = await request.get<{ enabled?: unknown }>('/v1/feature', { key: IVL_INVENTORY_FLAG }, {
    transformResponse: [(raw: unknown) => {
      try {
        const enabled: unknown = typeof raw === 'string' ? JSON.parse(raw) : raw
        // 인증 오류 본문은 그대로 두어 공용 인터셉터가 상태와 오류 코드를 읽게 한다.
        return typeof enabled === 'boolean' ? { enabled } : enabled
      } catch {
        return raw
      }
    }],
  })
  if (typeof response?.enabled !== 'boolean') throw new IvlInventoryUserError(INVENTORY_CONTRACT_ERROR)
  return response.enabled
}

export const getIvlInventoryStatuses = async (params: IvlInventoryRequest, signal?: AbortSignal) => {
  const response = await request.get<ApiResponseV2<unknown>>(`${INVENTORY_STATUSES_URL}?${toRepeatQuery(params)}`, undefined, { signal })
  const result = ivlInventoryResultSchema.safeParse(response.data)
  if (response.meta?.result !== 'SUCCESS' || !result.success
    || result.data.pageInfo.page !== params.page || result.data.pageInfo.size !== params.size) {
    throw new IvlInventoryUserError(INVENTORY_CONTRACT_ERROR)
  }
  return result.data
}

/** 서버가 제공하는 활성 센터 전체를 사용한다. 컷오프용 센터 목록의 제외 조건을 적용하지 않는다. */
export const getInventoryWarehouses = () =>
  request.post<ApiResponseV2<{ items: InventoryWarehouse[] }>, undefined>('/api/v1/get-all-warehouses', undefined)

/** 화면 페이지가 추가돼도 전체 다운로드에 섞이지 않도록 필터만 명시적으로 선택한다. */
export const buildIvlInventoryExcelUrl = (params: IvlInventoryExportRequest): string => {
  const { sprNm, logisticsServiceTypes, warehouseCode, barcode, skuId, brdNm, gdsCd, stlNo, stcBarcode, stcBrdNm, stcStlNo,
    includeZeroQuantity, viewerShipperCode, reasonCode, reasonDetail } = params
  return `${INVENTORY_STATUSES_EXCEL_URL}?${toRepeatQuery({
    sprNm, logisticsServiceTypes, warehouseCode, barcode, skuId, brdNm, gdsCd, stlNo, stcBarcode, stcBrdNm, stcStlNo,
    includeZeroQuantity, viewerShipperCode, reasonCode, reasonDetail,
  })}`
}
